/// Tek Istanbul/tr-TR tarih biçimleyici kümesi. Her biçim, ekranlarda daha önce yerel olarak
/// tanımlı olan Intl.DateTimeFormat çıktısıyla birebir aynıdır (taban görüntüleri kaymasın).
/// null/undefined/geçersiz girdi '—' döner.
type DateInput = string | Date | null | undefined;

const TZ = 'Europe/Istanbul';
const EMPTY = '—';

const make = (options: Intl.DateTimeFormatOptions): Intl.DateTimeFormat =>
  new Intl.DateTimeFormat('tr-TR', { ...options, timeZone: TZ });

const SHORT = make({ day: '2-digit', month: '2-digit', year: 'numeric' });
const SHORT_TIME = make({ day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const MEDIUM = make({ day: 'numeric', month: 'short', year: 'numeric' });
const MEDIUM_TIME = make({ day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const LONG = make({ day: 'numeric', month: 'long', year: 'numeric' });
const LONG_TIME = make({ day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const LONG_WEEKDAY = make({ day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' });
const TIME = make({ hour: '2-digit', minute: '2-digit' });
const MONTH_YEAR = make({ month: 'long', year: 'numeric' });

function format(fmt: Intl.DateTimeFormat, value: DateInput): string {
  if (value === null || value === undefined || value === '') return EMPTY;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? EMPTY : fmt.format(d);
}

/** `20.10.2026` */
export const formatShortDate = (v: DateInput): string => format(SHORT, v);
/** `20.10.2026 14:30` */
export const formatDateTime = (v: DateInput): string => format(SHORT_TIME, v);
/** `20 Eki 2026` */
export const formatMediumDate = (v: DateInput): string => format(MEDIUM, v);
/** `20 Eki 2026 14:30` */
export const formatMediumDateTime = (v: DateInput): string => format(MEDIUM_TIME, v);
/** `20 Ekim 2026` */
export const formatLongDate = (v: DateInput): string => format(LONG, v);
/** `20 Ekim 2026 14:30` */
export const formatLongDateTime = (v: DateInput): string => format(LONG_TIME, v);
/** `20 Ekim 2026 Salı` */
export const formatLongDateWithWeekday = (v: DateInput): string => format(LONG_WEEKDAY, v);
/** `14:30` */
export const formatTime = (v: DateInput): string => format(TIME, v);
/** `Ekim 2026` */
export const formatMonthYear = (v: DateInput): string => format(MONTH_YEAR, v);

/// Düz takvim tarihi (YYYY-MM-DD, saatsiz): saat dilimi dönüşümü yapılmaz, gün kaymaz.
const PLAIN_DAY_MONTH = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'short', timeZone: 'UTC' });

/** `'2026-10-20'` → `20 Eki`; çözülemeyen girdi olduğu gibi döner. */
export function formatPlainDayMonth(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return ymd;
  return PLAIN_DAY_MONTH.format(new Date(Date.UTC(y, m - 1, d)));
}
